export default __webpack_public_path__ + "media/components/Courses/Show/Images/disciplines/3-3ab86da141dc31c46d30a7ebeceb5527.svg";